import {SongList} from '../../Components/components'
import './allSongList.css'
import { useEffect, useState } from 'react'
import axios from 'axios'





export default function AllSongList(){
    const [songsData,setSongsData]=useState([])
    const [isLoading,setLoading]=useState(false)
    const PORT=process.env.REACT_APP_URL_PORT
    
    useEffect(()=>{
        axios.get(`https://${PORT}/admin/music_data`)
        .then(res=>{
            setSongsData(res.data)
            setLoading(true)
        })
        .catch("Error of data fetch")
    },[PORT])

    return(
            <>
            {
                !isLoading?
                <div className='mtmd'>Loading...</div>:
                <div className='row mtmd'>
                    <div className='col-12'>
                        <SongList path="new_song" songsData={songsData.new_songs}/>
                        <SongList path="old_song" songsData={songsData.old_songs}/>
                    </div>
                </div>
            }
            </>
    )
}

